"use client";

import StoreBox from "../store/store-box";
import ProductDetails from "./product-details";
import NotFound from "../common/NotFound";
import { useAppSelector } from "../slice/hooks";
import { getActiveCart } from "../slice/cart-slice";
import { useEffect, useMemo, useState } from "react";
import { CONFIG } from "../../lib/util/config";
import Skeleton from "react-loading-skeleton";
import { useToken } from "../../lib/context/auth-context";

import styles from "./index.module.css";

const ProductPage = (props) => {
  const cart = useAppSelector(getActiveCart);
  const {
    urlData,
    showCart,
    accessPointId,
    organisation,
    accessPoint,
    serverToken,
  } = props;
  const [productRes, setProductRes] = useState(urlData || null);
  const [loading, setLoading] = useState(!urlData);
  const { token } = useToken();

  function getCheckSumFromUrl() {
    if (typeof window === "undefined") return null;

    const slug = window.location.pathname.split("/").filter(Boolean);
    let checkSum = null;

    const productIndex = slug.indexOf("product");
    if (productIndex !== -1 && slug.length > productIndex + 1) {
      const productSegment = slug[productIndex + 1];
      const parts = productSegment.split("-");
      checkSum = parts.pop(); // last part after dash
    }

    return checkSum;
  }
  const checkSum = useMemo(() => getCheckSumFromUrl(), []);

  const fetchData = async (url) => {
    try {
      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token ? token : serverToken}`,
          "Content-Type": "application/json",
        },
        next: { revalidate: 10 },
      });
      return res.ok ? await res.json() : null;
    } catch (err) {
      return null;
    }
  };

  useEffect(() => {
    if (!urlData) {
      setLoading(true);
      async function loadProduct() {
        const res = await fetchData(
          `${CONFIG.apiUrl}/product/public/organisation/${organisation.orgId}/checksum/${checkSum}/info?useFeed=true&accessPointId=${accessPointId}`
        );
        setProductRes(res?.data?.product || null);
        setLoading(false);
      }
      loadProduct();
    }
  }, [urlData, checkSum, accessPointId, organisation.orgId]);
  const handleLocationChange = (e) => {};

  return (
    <StoreBox {...props} handleLocationChange={handleLocationChange}>
      <div className={styles.productDetails}>
        {loading ? (
          <div className="product-skeleton-container">
            <div className="product-skeleton">
              <div className="product-skeleton-big">
                <Skeleton width="100%" height="100%" />
              </div>
              <div className="product-skeleton-small">
                <Skeleton width="60px" height="60px" />
                <Skeleton width="60px" height="60px" />
                <Skeleton width="60px" height="60px" />
              </div>
            </div>
            <div className="product-skeleton">
              <div className="product-skeleton-big second">
                <Skeleton
                  width="100%"
                  height="40%"
                  style={{ marginBottom: 10 }}
                />
                <Skeleton width="100%" height="40%" />
              </div>

              <div className="product-skeleton-small">
                <Skeleton width="12rem" height="6rem" />
                <Skeleton width="12rem" height="6rem" />
              </div>
            </div>
          </div>
        ) : productRes ? (
          <ProductDetails
            cart={cart}
            product={productRes}
            showCart={showCart}
            enablePreview={true}
            accessPoint={accessPoint}
            organisation={organisation}
          />
        ) : (
          <NotFound />
        )}
      </div>
    </StoreBox>
  );
};

export default ProductPage;
